// src/store/slices/securityQuestionSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import securityQuestionApi from 'api/securityQuestionApi';

export const fetchQuestions = createAsyncThunk(
  'securityQuestion/fetchQuestions',
  async (_, { rejectWithValue }) => {
    try {
      const questions = await securityQuestionApi.getAll();
      return questions;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load questions');
    }
  }
);

const securityQuestionSlice = createSlice({
  name: 'securityQuestion',
  initialState: {
    questions: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.questions = action.payload;
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default securityQuestionSlice.reducer;